import { Mixins } from '@spectorasoftware/homegauge-vue';
import VueScrollTo from 'vue-scrollto';

const { FormValidationsMixin } = Mixins;

const VALIDATION_ERROR_SCROLL_CONTAINER = 'body';
const VALIDATION_ERROR_SCROLL_DURATION = 250;
const VALIDATION_ERROR_SCROLL_EASING = 'ease-in-out';
const VALIDATION_ERROR_SCROLL_ELEMENT = '#step-container--alerts';
const VALIDATION_ERROR_SCROLL_OFFSET = -25;

export default {
  computed: {
    ...FormValidationsMixin.computed,
  },
  methods: {
    ...FormValidationsMixin.methods,

    /**
     * Validate local VeeValidate instance and return result with
     * option to scroll to error container on failure
     *
     * @param {boolean} scrollToError
     * @returns {Promise<void>}
     */
    async validateForm(scrollToError) {
      const isValid = await this.$validator.validateAll();
      if (!isValid && scrollToError) {
        const firstError = this.$validator.errors.items[0];
        const firstErrorElement = firstError
          ? this.$el.querySelector(`[data-vv-name="${firstError.field}"]`)
          : null;

        VueScrollTo.scrollTo(
          firstErrorElement || VALIDATION_ERROR_SCROLL_ELEMENT,
          VALIDATION_ERROR_SCROLL_DURATION,
          {
            container: VALIDATION_ERROR_SCROLL_CONTAINER,
            easing: VALIDATION_ERROR_SCROLL_EASING,
            offset: VALIDATION_ERROR_SCROLL_OFFSET,
            force: true,
            cancelable: true,
            x: false,
            y: true,
          },
        );
      }
      return isValid;
    },
  },
};
